import type { LandingInfraContent, LandingWhyContent } from "../types";

export const landingWhy: LandingWhyContent = {
  title: {
    line1: "Built for traders.",
    line2Lead: "Built to ",
    line2Highlight: "stay funded",
    line2Tail: ".",
  },
  sub: "Most prop firms are designed to push traders out. Ours is designed to keep them trading, for years rather than weeks.",
  split: {
    eyebrow: "Profit split",
    baseSplitLabel: "BASE SPLIT",
    body: "Every account starts at an 80% split. Upgrade to 90% via the optional add-on at checkout. One lever, locked in for the life of your account.",
    yourShare: "YOUR SHARE",
    baseChipLabel: "BASE",
    addOnChipLabel: "WITH ADD-ON",
  },
  payouts: {
    pill: "FAST",
    title: "Payouts on demand.",
    body: "Bank, USDC/USDT or card. Real-time queue position in your dashboard.",
    methods: { usdc: "USDC", card: "CARD", bank: "BANK" },
  },
  execution: {
    eyebrow: "Execution",
    title: "Institutional execution.",
    body: "Live MetaTrader 5 with raw spreads, deep liquidity and consistent fills.",
    latency: "12ms median",
    spread: "0.1 pip avg",
  },
  scaling: {
    pill: "SCALING",
    title: "Scale your account.",
    body: "Documented growth steps up to a $1M allocation. Same risk structure, larger numbers.",
    upToPrefix: "up to",
    milestonePath: "milestone path",
  },
  evalLive: {
    eyebrow: "Same rules",
    title: "Evaluation = Live.",
    body: "What you trade in evaluation is exactly what you trade funded. No surprise rules at the goal-line.",
    evalPill: "EVAL",
    livePill: "LIVE",
    rules: {
      profitTarget: "Profit target",
      dailyLoss: "Daily loss",
      maxDd: "Max DD",
      leverage: "Leverage",
    },
  },
};

export const landingInfra: LandingInfraContent = {
  title: { line1: "Real markets.", line2Highlight: "Real execution." },
  sub: "STP execution, tier-1 bank liquidity, and MetaTrader 5. The same infrastructure professional desks rely on.",
  cards: {
    stpRouting: {
      eyebrow: "EXECUTION",
      title: "STP routing",
      body: "Orders route directly to the market with no dealing-desk intervention. Spreads and execution reflect real market conditions at all times.",
    },
    tier1Banks: {
      eyebrow: "LIQUIDITY",
      title: "Tier-1 banks",
      body: "Backed by top-tier institutional liquidity providers. The same desks that fill institutional flow on professional trading rooms.",
    },
    metaTrader5: {
      eyebrow: "PLATFORM",
      title: "MetaTrader 5",
      body: "Industry-standard execution and analysis platform. Algo trading, depth of market, multi-instrument. The platform professional desks use.",
    },
  },
};
